<template>
  <div class="lead-detail-page">
    <div class="container container--fluid">
      <Breadcrumb :items="breadcrumbs" class="lead-detail-page__breadcrumb" />
      <LeadDetailContent
        :lead-id="$route.params.id"
        @lead-archived="handleLeadRemoved"
        @lead-deleted="handleLeadRemoved"
      />
    </div>
  </div>
</template>

<script>
  import { defineComponent, computed, getCurrentInstance } from 'vue';
  import { useRouter } from 'vue-router';
  import { useCrmStore } from '@/store/crmStore';

  import PageHeader from '@/components/partials/PageHeader.vue';
  import LeadDetailContent from '@/components/crm/LeadDetailContent.vue';
  import Btn from '@/components/partials/Btn.vue';
  import BaseIcon from '@shared/components/BaseIcon.vue';
  import Breadcrumb from '@/components/partials/Breadcrumb.vue';

  export default defineComponent({
    name: 'LeadDetailPage',

    components: {
      PageHeader,
      LeadDetailContent,
      Btn,
      BaseIcon,
      Breadcrumb,
    },

    setup() {
      const instance = getCurrentInstance();
      const $t = instance.appContext.config.globalProperties.$t;
      const router = useRouter();
      const crmStore = useCrmStore();

      const lead = computed(() => crmStore.currentLead);

      const pageTitle = computed(() => {
        if (lead.value?.name) {
          return lead.value.name;
        }
        return $t('crm.lead_details');
      });

      const pageDescription = computed(() => {
        if (lead.value?.email) {
          return lead.value.email;
        }
        return $t('lead_details.view_and_manage_lead');
      });

      const breadcrumbs = computed(() => [
        {
          label: $t('crm.title'),
          url: '/crm',
          icon: 'users',
        },
        {
          label: pageTitle.value || $t('crm.unknown_lead'),
        },
      ]);

      const goBack = () => {
        // Check if there's a history to go back to
        if (window.history.length > 1) {
          router.go(-1);
        } else {
          // Fallback to CRM page
          router.push('/crm');
        }
      };

      const handleLeadRemoved = () => {
        router.push('/crm');
      };

      return {
        pageTitle,
        pageDescription,
        breadcrumbs,
        goBack,
        handleLeadRemoved,
      };
    },
  });
</script>

<style scoped lang="scss">
  .lead-detail-page {
    min-height: 100vh;
    background: var(--slate-50);

    &__breadcrumb {
      margin: 20px 0 1rem 0;
    }
  }
</style>
